<template>
	<div>
		<!--工具条-->
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item v-if="Limits.unallocatedreservation_create">
  					<el-button type="primary" size="small" @click="Goadd">添加预约</el-button>
  				</el-form-item>
				<el-form-item>
					<el-input placeholder="请输入内容" v-model="inputMore" class="input-with-select" size="small">
					    <el-select v-model="selectMore" slot="prepend" placeholder="请选择">
					    	<el-option label="请选择" value=""></el-option>
						    <el-option label="姓名" value="1"></el-option>
						    <el-option label="手机号" value="2"></el-option>
					    </el-select>
				    <el-button slot="append" icon="el-icon-search" @click="Find">查询</el-button>
				  </el-input>
				</el-form-item>
				<!--<el-form-item>
					<el-select v-model="allot" placeholder="分配经销商为..." size="small" style="width: 200px;" @change="Allot">
	    				<el-option v-for="item in Dealerlist" :label='item.name' key="item" :value='item.id'></el-option>
	  				</el-select>
  				</el-form-item>-->
  				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">快速筛选:</el-button>
				</el-form-item>
  				<el-form-item>
					<el-select v-model="Sex" placeholder="所有性别" size="small" style="width: 100px;" @change="Quickfind">
	    				<el-option label="全部性别" value=""></el-option>
	    				<el-option label="男" value="1"></el-option>
	    				<el-option label="女" value="2"></el-option>
	  				</el-select>
  				</el-form-item>
  				<el-form-item>
					<el-select v-model="IsChecked" placeholder="所有审核" size="small" style="width: 100px;" @change="Quickfind">
	    				<el-option label="所有审核" value=""></el-option>
	    				<el-option label="未审核" value="0"></el-option>
	    				<el-option label="已审核" value="1"></el-option>
	  				</el-select>
  				</el-form-item>
  				
  				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
				</el-form-item>
			</el-form>
			
		</el-col>
		
		<el-table :data="List" border v-loading="listloading" style="width: 99.9%" :max-height="maxHeight">
		    <!--<el-table-column type="selection" :selectable='checkboxInit' width="35"></el-table-column>-->
		    <el-table-column type="expand">
		      	<template slot-scope="props">
			        <el-form label-position="left" inline class="demo-table-expand">
			          	<el-form-item label="用户名：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.name}}</span>
			        	</el-form-item>
			        	<el-form-item label="年龄：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.age}}</span>
			        	</el-form-item>
			        	<el-form-item label="身高：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.height}}cm</span>
			        	</el-form-item>
			        	<el-form-item label="体重：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.weight}}kg</span>
			        	</el-form-item>
			        	<el-form-item label="微信：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.wechat}}</span>
			        	</el-form-item>
			        	<el-form-item label="预约体验点：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.experience_point}}</span>
			        	</el-form-item>
			        	<!--<el-form-item label="详细住址：" style="width: 90%;margin-bottom: 0;">
			            	<span>{{props.row.address}}</span>
			        	</el-form-item>-->
			        	<el-form-item label="病症描述：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.injury_condition}}</span>
			        	</el-form-item>
			        	<el-form-item label="详细病情描述：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.injury_segment}}</span>
			        	</el-form-item>
			        	<el-form-item label="愈后至今：" style="width: 30%;margin-bottom: 0;">
			            	<span>{{props.row.injury_time}}</span>
			        	</el-form-item>
			        	<el-form-item label="上身、手臂能否正常抓握重物？" style="width: 30%;margin-bottom: 0;">
				            <span v-if="props.row.answer_1 == 1">是</span>
				            <span v-if="props.row.answer_1 == 0">否</span>
				        </el-form-item>
				          <el-form-item label="是否有骨质疏松？" style="width: 30%;margin-bottom: 0;">
				            <span v-if="props.row.answer_2 == 1">是</span>
				            <span v-if="props.row.answer_2 == 0">否</span>
				          </el-form-item>
				          <el-form-item label="是否有体位性低血压症状？" style="width: 30%;margin-bottom: 0;">
				            <span v-if="props.row.answer_3 == 1">是</span>
				            <span v-if="props.row.answer_3 == 0">否</span>
				          </el-form-item>
				          <el-form-item label="最近一个月内是否有做康复性训练？" style="width: 30%;margin-bottom: 0;">
				            <span v-if="props.row.answer_4 == 1">是</span>
				            <span v-if="props.row.answer_4 == 0">否</span>
				          </el-form-item>
				          <el-form-item label="是否有认知障碍？" style="width: 30%;margin-bottom: 0;">
				            <span v-if="props.row.answer_5 == 1">是</span>
				            <span v-if="props.row.answer_5 == 0">否</span>
				          </el-form-item>
				          <el-form-item label="最近三个月是否有通过站立架训练？" style="width: 30%;margin-bottom: 0;">
				            <span v-if="props.row.answer_6 == 1">是</span>
				            <span v-if="props.row.answer_6 == 0">否</span>
				          </el-form-item>
				          <el-form-item label="备注：" style="width: 100%;margin-bottom: 0;">
			            	<span>{{props.row.remarks }}</span>
			        	</el-form-item>
			        </el-form>
		      	</template>
    		</el-table-column>
		    <!--<el-table-column label="状态" prop="is_read" width="50"></el-table-column>-->
		    <el-table-column label="姓名" prop="name" width="80"></el-table-column>
		    <el-table-column label="性别" prop="gender.gender" width="50"></el-table-column>
		    <el-table-column label="手机" prop="phone" width="120"></el-table-column>
		    <el-table-column label="经销商" prop="dealer">
		    	<template slot-scope="scope">
		    		{{scope.row.dealer}}
		    		<el-button type="primary" v-if="scope.row.is_audit == 1 && Limits.unallocatedreservation_allocate" size="mini" icon="el-icon-caret-bottom" style="padding: 3px;" @click="JXSvisible(scope.$index,scope.row)"></el-button>
		    		<!--<el-button type="primary" v-if="scope.row.is_audit == 0" size="mini" icon="el-icon-caret-bottom" style="padding: 3px;" disabled></el-button>-->
		    	</template>
		    </el-table-column>
		    <el-table-column label="是否本人预约" prop="is_self" width="50"></el-table-column>
		    <el-table-column label="预约来源" prop="approach" width="50"></el-table-column>
		    <!--<el-table-column label="跟进状态" prop="followStatus" width="80"></el-table-column>-->
		    <el-table-column label="常住地" prop="address.totalAddress"></el-table-column>
		    <el-table-column label="预约时间" prop="submit_date" :formatter="dateFormat" width="160"></el-table-column>
		    <!--<el-table-column label="审核状态" prop="is_audit" width="80"></el-table-column>-->
		    <el-table-column label="操作" width="130">
		    	<template slot-scope="scope">
		    		<el-button v-if="scope.row.is_audit == 0 && Limits.unallocatedreservation_audit" style="padding: 7px;" type="primary" size="mini" @click="Check(scope.$index,scope.row)">审核</el-button>
		    		<el-button v-if="scope.row.is_audit == 1 && Limits.unallocatedreservation_audit" style="padding: 7px;" type="success" size="mini" disabled>已审核</el-button>
		    		<el-button v-if="Limits.unallocatedreservation_update" type="primary" size="mini" style="padding: 7px;" @click="Revamp(scope.$index,scope.row)">修改</el-button>
		    	</template>
		    </el-table-column>
		    <el-table-column label="删除" width="50" v-if="Limits.unallocatedreservation_delete">
		    	<template slot-scope="scope">
		    		<el-button type="danger" style="padding: 7px;" size="mini" icon="el-icon-delete" @click="Delete(scope.$index,scope.row)"></el-button>
		    	</template>
		    </el-table-column>
  		</el-table>
  		
  		<el-col :span="24" class="toolbar downtool">
        	<el-button v-if="Limits.deletedreservation_index" type="primary" size="small" @click="ShowDeleted">显示已删除预约</el-button>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;"></el-pagination>
		</el-col>
		
		<el-dialog title="已删除预约" :visible.sync="DeleteVisible" :fullscreen="true" :before-close="Backchange">
			<div>
			<el-table :data="List2" border v-loading="listloading2">
			    <el-table-column prop="name" label="姓名"></el-table-column>
			    <el-table-column prop="gender.gender" label="性别"></el-table-column>
			    <el-table-column prop="phone" label="手机"></el-table-column>
			    <el-table-column prop="dealer" label="所属经销商"></el-table-column>
			    <el-table-column prop="follow_status" label="跟进状态"></el-table-column>
			    <el-table-column prop="address.totalAddress" label="常住地"></el-table-column>
			    <el-table-column prop="submit_date" label="预约时间" :formatter="dateFormat" ></el-table-column>
			    <el-table-column label="操作" width="60" v-if="Limits.deletedreservation_enable">
			    	<template slot-scope="scope">
			    		<el-button type="success" size="mini" style="padding: 7px;" @click="Open(scope.$index,scope.row)">恢复</el-button>
			    	</template>
			    </el-table-column>
  			</el-table>
  		
  			<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange2" :page-size="Pagesize2" :current-page="Curpage2" :total="total2" style="float:right;">
			</el-pagination>
			</el-col>
			</div>
		</el-dialog>
		<!--修改经销商-->
		<el-dialog :title="Tname" :visible.sync="AllotVisible" center width="30%">
			<el-select v-model="allot" placeholder="分配经销商为..." size="small" style="width: 100%">
	    		<el-option v-for="item in Dealerlist" :label='item.name' :key="item.id" :value='item.id'></el-option>
	  		</el-select>
	  		<div slot="footer" class="dialog-footer">
		    	<el-button size="small" type="primary" @click="Allot" style="padding: 10px 50px;" :loading="Cjsxloading">提 交</el-button>
		  	</div>
		</el-dialog>
		
		<!--添加新预约-->
		<el-dialog :title="Title" :visible.sync="AddnewVisible" width="50%" top="1%" center>
			<div><span style="color: red;">*</span>个人基本信息</div>
			<el-form :inline="true">
				<!--<el-form-item>
					<el-select placeholder="是否本人报名？" size="small" style="width: 100px;" @change="Quickfind">
	    				<el-option label="全部性别" value=""></el-option>
	    				<el-option label="是本人报名" value="1"></el-option>
	    				<el-option label="帮他人报名" value="2"></el-option>
	  				</el-select>
  				</el-form-item>-->
				<el-form-item>
  					<el-input v-model="Name" placeholder="请输入姓名" size="mini">
    					<template slot="prepend">姓名</template>
  					</el-input>
  				</el-form-item>	
  				<el-form-item>
  					<el-input v-model="Phone" placeholder="请输入手机号" size="mini">
    					<template slot="prepend">手机</template>
  					</el-input>
  				</el-form-item>
  				<el-form-item>
					<el-select v-model="CSex" placeholder="性别" size="mini" style="width: 100px;">
	    				<el-option label="男" value="1"></el-option>
	    				<el-option label="女" value="2"></el-option>
	  				</el-select>
  				</el-form-item>
  				<el-form-item>
  					<el-input v-model="Age" placeholder="请输入年龄" size="mini">
    					<template slot="prepend">年龄</template>
  					</el-input>
  				</el-form-item>
  				<el-form-item>
  					<el-input v-model="Tall" placeholder="请输入身高(cm)" size="mini">
    					<template slot="prepend">身高</template>
  					</el-input>
  				</el-form-item>
  				<el-form-item>
  					<el-input v-model="Weight" placeholder="请输入体重(kg)" size="mini">
    					<template slot="prepend">体重</template>
  					</el-input>
  				</el-form-item>
  				
  				<el-form-item>
  					<el-input v-model="Wecha" placeholder="请输入微信号(选填)" size="mini">
    					<template slot="prepend">微信</template>
  					</el-input>
  				</el-form-item>
  				<el-form-item v-if="this.Cnum == 2">
  					是否本人预约？：
  					<el-select v-model="Isself" size="mini" style="width: 125px" placeholder="是否本人预约"> 
	                    <el-option label="是" value="1"></el-option>
	                    <el-option label="否" value="0"></el-option>  
                	</el-select>
                </el-form-item>	
  				<el-form-item>
  					您的地址：
  					<el-select v-model="selectProv" size="mini" style="width: 115px" placeholder="请选择省份" v-on:change="getProv($event)"> 
	                    <el-option label="常住地-省" value=""></el-option>
	                    <el-option v-for="item in provs" :label="item.label" :value="item.value" :key="item.value"></el-option>  
                	</el-select> 
                	<el-select v-model="selectCity" size="mini" style="width: 115px" placeholder="请选择城市">  
	                    <el-option label="常住地-市" value=""></el-option>
	                    <el-option v-for="item in citys" :label="item.label" :value="item.value" :key="item.value"></el-option>  
               		</el-select>
               		<el-input v-model="Address" placeholder="请输入详细地址(省/市不填)" size="mini" style="width: 37%;">
  					</el-input>
  				</el-form-item>
  				<el-form-item>
  					请选择预约体验点:
					<el-select v-model="Point" placeholder="请选择预约体验点" size="mini" style="width: 180px;">
	    				<el-option label="北京" value="北京"></el-option>
	    				<el-option label="上海" value="上海"></el-option>
	    				<el-option label="杭州" value="杭州"></el-option>
	    				<el-option label="苏州" value="苏州"></el-option>
	    				<el-option label="南京" value="南京"></el-option>
	    				<el-option label="广州" value="广州"></el-option>
	  				</el-select>
  				</el-form-item>
  				<el-form-item>
	  				<el-input v-model="KnowWhere" placeholder="您从哪里了解的邦邦车(必填)" size="mini" style="width:300px">
					    <el-select v-model="KnowWhereC" slot="prepend" placeholder="请选择">
					      	<el-option label="医院" value="1"></el-option>
					      	<el-option label="个人" value="2"></el-option>
					      	<el-option label="其他" value="3"></el-option>
					    </el-select>
				  	</el-input>
			  	</el-form-item>
			</el-form>
			<div><span style="color: red;">*</span>身体基本信息</div>
			<el-form>
				<el-form-item>
					<el-input v-model="bodyone" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="症状描述(什么类型？例：脑瘫、脑髓炎等)"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="bodytwo" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="详细病情描述(例：脊柱损伤L5-L6，没有受伤则写无)"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="bodythree" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="愈后至今约多少时间"></el-input>
				</el-form-item>
			</el-form>
			<div style="text-align: center;"><span style="color: red;">*</span>身体情况确认</div>
			<el-form>
				<el-form-item style="margin-bottom: 0;">
					<div style="text-align: center;">1、单手能否提起20kg重物？</div>
					<div style="text-align: center;">
						<el-radio v-model="Q1" label="1">是</el-radio>
	  					<el-radio v-model="Q1" label="0">否</el-radio>
					</div>
				</el-form-item>
				<el-form-item style="margin-bottom: 0;">
					<div style="text-align: center;">2、是否有骨质疏松？</div>
					<div style="text-align: center;">
					<el-radio v-model="Q2" label="1">是</el-radio>
  					<el-radio v-model="Q2" label="0">否</el-radio>
  					</div>
				</el-form-item>
				<el-form-item style="margin-bottom: 0;"> 
					<div style="text-align: center;">3、是否有体位性低血压症状？</div>
					<div style="text-align: center;">
					<el-radio v-model="Q3" label="1">是</el-radio>
  					<el-radio v-model="Q3" label="0">否</el-radio>
  					</div>
				</el-form-item>
				<el-form-item style="margin-bottom: 0;">
					<div style="text-align: center;">4、最近一个月内是否有做康复性训练？</div>
					<div style="text-align: center;">
					<el-radio v-model="Q4" label="1">是</el-radio>
  					<el-radio v-model="Q4" label="0">否</el-radio>
  					</div>
				</el-form-item>
				<el-form-item style="margin-bottom: 0;">
					<div style="text-align: center;">5、是否有认知障碍？(包括感知障碍、记忆障碍、思维障碍)</div>
					<div style="text-align: center;">
					<el-radio v-model="Q5" label="1">是</el-radio>
  					<el-radio v-model="Q5" label="0">否</el-radio>
  					</div>
				</el-form-item>
				<el-form-item style="margin-bottom: 0;">
					<div style="text-align: center;">6、最近三个月是否有通过站立架训练？</div>
					<div style="text-align: center;">
					<el-radio v-model="Q6" label="1">是</el-radio>
  					<el-radio v-model="Q6" label="0">否</el-radio>
  					</div>
				</el-form-item>
				<el-form-item>
					<el-input v-model="More" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="备注(有无其他症状，没有则写无。)"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
		    	<el-button size="small" type="primary" @click="GetUpload" style="padding: 10px 50px;" :loading="GetUploadloading">提 交</el-button>
		  	</div>
		</el-dialog>
	</div>
</template>

<script>
	import {GetUnreservationlistlist,GetDealerlist,GetDelreserlist} from '../api/api';
	
	export default {
		data (){
			return {
				maxHeight:500,
				provs:[{label:"北京市",value:"北京市"},
	            {label:"天津市",value:"天津市"},
	            {label:"河北省",value:"河北省"},  
	            {label:"山西省",value:"山西省"},  
	            {label:"内蒙古自治区",value:"内蒙古自治区"},  
	            {label:"辽宁省",value:"辽宁省"},  
	            {label:"吉林省",value:"吉林省"},  
	            {label:"黑龙江省",value:"黑龙江省"},  
	            {label:"上海市",value:"上海市"},  
	            {label:"江苏省",value:"江苏省"},  
	            {label:"浙江省",value:"浙江省"},  
	            {label:"安徽省",value:"安徽省"},  
	            {label:"福建省",value:"福建省"},  
	            {label:"江西省",value:"江西省"},  
	            {label:"山东省",value:"山东省"},  
	            {label:"河南省",value:"河南省"},  
	            {label:"湖北省",value:"湖北省"},  
	            {label:"湖南省",value:"湖南省"},  
	            {label:"广东省",value:"广东省"},  
	            {label:"广西壮族自治区",value:"广西壮族自治区"},  
	            {label:"海南省",value:"海南省"},  
	            {label:"重庆市",value:"重庆市"},  
	            {label:"四川省",value:"四川省"},  
	            {label:"贵州省",value:"贵州省"},  
	            {label:"云南省",value:"云南省"},  
	            {label:"西藏自治区",value:"西藏自治区"},  
	            {label:"陕西省",value:"陕西省"},  
	            {label:"甘肃省",value:"甘肃省"},  
	            {label:"青海省",value:"青海省"},  
	            {label:"宁夏回族自治区",value:"宁夏回族自治区"},  
	            {label:"新疆维吾尔自治区",value:"新疆维吾尔自治区"},  
	            {label:"台湾省",value:"台湾省"},  
	            {label:"香港特别行政区",value:"香港特别行政区"},  
	            {label:"澳门特别行政区",value:"澳门特别行政区"}] ,
	            Limits:"",
	            Name:"",
	            CSex:"",
	            Age:"",
	            Tall:"",
	            Weight:"",
	            Phone:"",
	            Wecha:"",
	            Isself:"",
	            Address:"",
	            Point:"",
	            KnowWhere:"",
	            KnowWhereC:"",
	            bodyone:"",
	            bodytwo:"",
	            bodythree:"",
                citys:[],  
                selectProv:'',  
                selectCity:'',
                Q1:"",Q2:"",Q3:"",Q4:"",Q5:"",Q6:"",
                More:"",
                Title:"",
                Cnum:0,
				token:"",
				inputMore:"",
				selectMore:"",
				GetUploadloading:false,
				allot:"",
				List:[],
//				sels:[],
				listloading:false,
				AllotVisible:false,
				Cjsxloading:false,
				State:"",
				Sex:"",
				Dealer:"",
				Follow:"",
				Audit:"",
				Pagesize:20,
				Curpage:1,
				total:1,
				IsChecked:"",
				Dealerlist:[],
				DeleteVisible:false,
				List2:[],
				listloading2:false,
				Pagesize2:20,
				Curpage2:1,
				total2:1,
        		form:{},
        		Form:{
        			id:"",
        			name:"",
        			learn_from:0,
        			learn_from_detail:"",
        			Q1:0,Q2:0,Q3:0,Q4:0,Q5:0,Q6:0
        		},
        		Form2:{
        			id:""
        		},
        		Tname:"",
        		Screenall:{},
        		MediumCode:1,
        		AddnewVisible:false
			}
		},
		methods:{
//			分配经销商
			Allot(){
				if(this.allot){
					this.Cjsxloading = true
					let ur = "/unallocatedreservations/"+this.Form.id+"/handler?token=" + this.token
					this.axios.put(ur,{"dealer_id":this.allot}).then(res => {
						if(res.status == 200){
							this.$message({
				            	type: 'success',
				            	message: '分配成功!'
				          	});
				          	this.AllotVisible = false
				          	this.Cjsxloading = false
				          	this.GetList(GetUnreservationlistlist,{page:this.Curpage,token:this.token,sort:"-submit_date"})
						}else{
							this.$message.error("对不起，请求失败。")
							this.Cjsxloading = false
						}
					}).catch(err => {
						this.$message.error(err.response.data.message)
						this.Cjsxloading = false
					})
				}
			},
			Find(){
				if(this.selectMore && this.inputMore){
					this.Quickfind()
				}
			},
			Quickfind(){
//				Sex
				var all
				if(this.inputMore && this.selectMore){
					if(this.selectMore == 1){
						all = {
							name:'~'+this.inputMore,
							gender_code:this.Sex,
							is_audit:this.IsChecked
							
						}
					}else if(this.selectMore == 2){
						all = {
							phone:'~'+this.inputMore,
							gender_code:this.Sex,
							is_audit:this.IsChecked
						}
					}
				}else{
					all = {
						gender_code:this.Sex,
						is_audit:this.IsChecked
					}
				}
				this.Screenall = {}
				for(var i in all){
					if(all[i]){
						this.Screenall[i] = all[i]
							continue
						}
				}
				if(this.Sex || this.IsChecked || (this.selectMore && this.inputMore)){
					this.GetList(GetUnreservationlistlist,{page:this.Curpage,token:this.token,sort:"-submit_date",q:JSON.stringify([{"AND":this.Screenall}])})
				}else{
					this.GetList(GetUnreservationlistlist,{page:this.Curpage,token:this.token,sort:"-submit_date"})
				}
			},
			handleCurrentChange(val){
				this.Curpage = val
				this.Quickfind()
			},
			Refresh(){
				this.Curpage = 1
				this.Sex = ""
				this.IsChecked = ""
				this.selectMore = ""
				this.inputMore = ""
				this.GetList(GetUnreservationlistlist,{page:this.Curpage,token:this.token,sort:"-submit_date"})
			},
			ShowDeleted(){
				this.DeleteVisible = true
				this.GetList2(GetDelreserlist,{page:this.Curpage2,token:this.token,sort:"-submit_date"})
			},
			Goadd(){
				this.Cnum = 1
				this.AddnewVisible = true 
				this.Title = "添加预约"
			},
			Revamp(index,row){
				this.Cnum = 2
				this.AddnewVisible = true 
				this.Title = "修改预约单"
				this.Form = Object.assign({}, row);
				if(this.Form.is_self == "是"){
					this.Isself = "1"
				}else if(this.Form.is_self == "否"){
					this.Isself = "0"
				}
				this.Name = this.Form.name
				this.CSex = this.Form.gender.code + ""
				this.Age = this.Form.age
				this.Tall = this.Form.height
				this.Weight = this.Form.weight
				this.Phone = this.Form.phone
				this.Wecha = this.Form.wechat
				this.selectProv = this.Form.address.province
				this.selectCity = this.Form.address.city
				this.Address = this.Form.address.detailAddress
				this.Point = this.Form.experience_point
				this.KnowWhereC = this.Form.learn_from + ""
				this.KnowWhere = this.Form.learn_from_detail
				this.bodyone = this.Form.injury_condition
				this.bodytwo = this.Form.injury_segment
				this.bodythree = this.Form.injury_time
				this.Q1 = this.Form.answer_1 + ""
				this.Q2 = this.Form.answer_2 + ""
				this.Q3 = this.Form.answer_3 + ""
				this.Q4 = this.Form.answer_4 + ""
				this.Q5 = this.Form.answer_5 + ""
				this.Q6 = this.Form.answer_6 + ""
				this.More = this.Form.remark
				console.log(this.CSex)
			},
			Backchange(){
				if(this.MediumCode == 2){
					this.GetList(GetUnreservationlistlist,{page:this.Curpage,token:this.token,sort:"-submit_date"})
					this.MediumCode = 1
				}
				this.DeleteVisible = false
			},
			handleCurrentChange2(val){
				this.Curpage2 = val
			},
			Open(index,row){
				this.Form2 = Object.assign({}, row);
				let ul = "/deletedreservations/"+this.Form2.id+"/enable?token="+this.token
				this.axios.put(ul).then(res => {
					if(res.status == 200){
						this.$message({
			            	type: 'success',
			            	message: '恢复成功!'
			          	});
			          	this.MediumCode = 2
			          	this.GetList2(GetDelreserlist,{page:this.Curpage2,token:this.token,sort:"-submit_date"})
					}else{
						this.$message.error("对不起，请求失败。")
					}
				}).catch(err => {
					this.$message.error(err.response.data.message)
				})
			},
//			审核
			Check(index,row){
				this.$confirm('是否确认审核?', '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
			    }).then(() => {
			    	this.listloading = true
					this.Form = Object.assign({}, row);
					let url = "/unallocatedreservations/"+ this.Form.id +"/auditStatus?token="+this.token
					this.axios.put(url).then(res => {
						if(res.status == 200){
							this.$message({
				            	type: 'success',
				            	message: '审核成功!'
				          	});
				          	this.GetList(GetUnreservationlistlist,{page:this.Curpage,token:this.token,sort:"-submit_date"})
						}else{
							this.listloading = false
							this.$message.error("对不起，请求失败。")
						}
					}).catch(err => {
						this.listloading = false
						this.$message.error(err.response.data.message)
					})
			    }).catch(() => {
			    	this.$message({
			        	type: 'info',
			            message: '已取消操作'
			        }); 
			    })
				
			},
//			打开分配经销商窗口
			JXSvisible(index,row){
				this.allot = ""
				this.AllotVisible = true
				this.Form = Object.assign({}, row);
				this.Tname = "分配经销商 ["+ this.Form.name +"]"
			},
			Delete(index,row){
				this.$confirm('确认删除该条预约?', '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
			    }).then(()=>{
			    	this.listloading = true
					this.Form = Object.assign({}, row);
					let u = '/unallocatedreservations/'+this.Form.id
					this.Del(u,GetUnreservationlistlist,{page:this.Curpage,token:this.token,sort:"-submit_date"})
			    }).catch(()=>{
			    	this.$message({
			        	type: 'info',
			            message: '已取消删除'
			        });   
			    })
			},
			GetUpload(){
					var that = this
					if(this.Name == "" || this.CSex == "" || this.Age == "" || this.Tall == "" || this.Weight =="" ||
					this.Phone == "" || this.selectProv =="" || this.selectCity == "" || this.Address == "" ||
					this.Point == "" || this.KnowWhereC == "" || this.KnowWhere == "" || this.bodyone == "" || 
					this.bodytwo == "" || this.bodythree == "" || this.Q1 == "" || this.Q2 == "" || this.Q3 == "" ||
					this.Q4 == "" || this.Q5 == "" || this.Q6 == ""){
					 	this.$message.error("请将信息填写完整后再提交，谢谢。")
					}else{
						if(that.Cnum == 1){
							this.GetUploadloading = true
							let para = {
								"is_self":"0",
							    "name": this.Name,
							    "gender_code":this.CSex,
							    "age": this.Age,
							    "height": this.Tall,
							    "weight": this.Weight,
							    "phone": this.Phone,
							    "wechat":this.Wecha,
							    "approach":"f",
							    "province": this.selectProv,
							    "city": this.selectCity,
							    "address": this.Address,
							    "experience_point": this.Point,
							    "learn_from": this.KnowWhereC,
							    "learn_from_detail": this.KnowWhere,
							    "injury_condition": this.bodyone,
							    "injury_segment": this.bodytwo,
							    "injury_time": this.bodythree,
							    "answer_1":this.Q1,
							    "answer_2":this.Q2,
							    "answer_3":this.Q3,
							    "answer_4":this.Q4,
							    "answer_5":this.Q5,
							    "answer_6":this.Q6,
							    "remark": this.More,
							    "way_code":"99"
							}
							let rl = "/unallocatedreservations?token="+this.token
							this.axios.post(rl,para).then(res => {
								if(res.status == "201"){
									this.$message({
						            	type: 'success',
						            	message: '操作成功!'
						          	});
						          	this.GetUploadloading = false
						          	this.AddnewVisible = false
						          	this.Name = ""
						          	this.CSex = ""
						          	this.Age = ""
						          	this.Tall = ""
						          	this.Weight = ""
						          	this.Phone = ""
						          	this.Wecha = ""
						          	this.selectProv = ""
						          	this.selectCity = ""
						          	this.Address = ""
						          	this.Point = ""
						          	this.KnowWhereC = ""
						          	this.KnowWhere = ""
						          	this.bodyone = ""
						          	this.bodytwo = ""
						          	this.bodythree = ""
						          	this.Q1 = ""
						          	this.Q2 = ""
						          	this.Q3 = ""
						          	this.Q4 = ""
						          	this.Q5 = ""
						          	this.Q6 = ""
						          	this.More = ""
						          	this.Curpage = 1
						          	this.GetList(GetUnreservationlistlist,{page:this.Curpage,token:this.token,sort:"-submit_date"})
								}else{
									this.$message.error('对不起，操作失败。')
									this.GetUploadloading = false
								}
							}).catch(err => {
								this.$message.error(err.response.data.message)
								this.GetUploadloading = false
							})
						}else if(that.Cnum == 2){
							this.GetUploadloading = true
							let para = {
								"is_self":this.Isself,
							    "name": this.Name,
							    "gender_code":this.CSex,
							    "age": this.Age,
							    "height": this.Tall,
							    "weight": this.Weight,
							    "phone": this.Phone,
							    "wechat":this.Wecha,
							    "province": this.selectProv,
							    "city": this.selectCity,
							    "address": this.Address,
							    "experience_point": this.Point,
							    "learn_from": this.KnowWhereC,
							    "learn_from_detail": this.KnowWhere,
							    "injury_condition": this.bodyone,
							    "injury_segment": this.bodytwo,
							    "injury_time": this.bodythree,
							    "answer_1":this.Q1,
							    "answer_2":this.Q2,
							    "answer_3":this.Q3,
							    "answer_4":this.Q4,
							    "answer_5":this.Q5,
							    "answer_6":this.Q6,
							    "remark": this.More,
							}
							let rl = "/unallocatedreservations/"+this.Form.id+"?token="+this.token
							this.axios.put(rl,para).then(res => {
								if(res.status == "200"){
									this.$message({
						            	type: 'success',
						            	message: '操作成功!'
						          	});
						          	this.GetUploadloading = false
						          	this.AddnewVisible = false
						          	this.GetList(GetUnreservationlistlist,{page:this.Curpage,token:this.token,sort:"-submit_date"})
								}else{
									this.$message.error('对不起，操作失败。')
									this.GetUploadloading = false
								}
							}).catch(err => {
								this.$message.error(err.response.data.message)
								this.GetUploadloading = false
							})
						}
					}
			},
			getProv(prov){
				let tempCity=[];                
                this.citys=[];  
                this.selectCity='';                 
                let allCity=[{
                    prov: "北京市",  
                    label: "东城区"  
                }, {  
                    prov: "北京市",  
                    label: "西城区"  
                }, {  
                    prov: "北京市",  
                    label: "崇文区"  
                }, {  
                    prov: "北京市",  
                    label: "宣武区"  
                }, {  
                    prov: "北京市",  
                    label: "朝阳区"  
                }, {  
                    prov: "北京市",  
                    label: "丰台区"  
                }, {  
                    prov: "北京市",  
                    label: "石景山区"  
                }, {  
                    prov: "北京市",  
                    label: "海淀区"  
                }, {  
                    prov: "北京市",  
                    label: "门头沟区"  
                }, {  
                    prov: "北京市",  
                    label: "房山区"  
                }, {  
                    prov: "北京市",  
                    label: "通州区"  
                }, {  
                    prov: "北京市",  
                    label: "顺义区"  
                }, {  
                    prov: "北京市",  
                    label: "昌平区"  
                }, {  
                    prov: "北京市",  
                    label: "大兴区"  
                }, {  
                    prov: "北京市",  
                    label: "怀柔区"  
                }, {  
                    prov: "北京市",  
                    label: "平谷区"  
                }, {  
                    prov: "北京市",  
                    label: "密云县"  
                }, {  
                    prov: "北京市",  
                    label: "延庆县"  
                }, {  
                    prov: "北京市",  
                    label: "延庆镇"  
                }, {  
                    prov: "天津市",  
                    label: "和平区"  
                }, {  
                    prov: "天津市",  
                    label: "河东区"  
                }, {  
                    prov: "天津市",  
                    label: "河西区"  
                }, {  
                    prov: "天津市",  
                    label: "南开区"  
                }, {  
                    prov: "天津市",  
                    label: "河北区"  
                }, {  
                    prov: "天津市",  
                    label: "红桥区"  
                }, {  
                    prov: "天津市",  
                    label: "塘沽区"  
                }, {  
                    prov: "天津市",  
                    label: "汉沽区"  
                }, {  
                    prov: "天津市",  
                    label: "大港区"  
                }, {  
                    prov: "天津市",  
                    label: "东丽区"  
                }, {  
                    prov: "天津市",  
                    label: "西青区"  
                }, {  
                    prov: "天津市",  
                    label: "津南区"  
                }, {  
                    prov: "天津市",  
                    label: "北辰区"  
                }, {  
                    prov: "天津市",  
                    label: "武清区"  
                }, {  
                    prov: "天津市",  
                    label: "宝坻区"  
                }, {  
                    prov: "天津市",  
                    label: "蓟县"  
                }, {  
                    prov: "天津市",  
                    label: "宁河县"  
                }, {  
                    prov: "天津市",  
                    label: "芦台镇"  
                }, {  
                    prov: "天津市",  
                    label: "静海县"  
                }, {  
                    prov: "天津市",  
                    label: "静海镇"  
                }, {  
                    prov: "河北省",  
                    label: "石家庄市"  
                }, {  
                    prov: "河北省",  
                    label: "唐山市"  
                }, {  
                    prov: "河北省",  
                    label: "秦皇岛市"  
                }, {  
                    prov: "河北省",  
                    label: "邯郸市"  
                }, {  
                    prov: "河北省",  
                    label: "邢台市"  
                }, {  
                    prov: "河北省",  
                    label: "保定市"  
                }, {  
                    prov: "河北省",  
                    label: "张家口市"  
                }, {  
                    prov: "河北省",  
                    label: "承德市"  
                }, {  
                    prov: "河北省",  
                    label: "沧州市"  
                }, {  
                    prov: "河北省",  
                    label: "廊坊市"  
                }, {  
                    prov: "河北省",  
                    label: "衡水市"  
                }, {  
                    prov: "山西省",  
                    label: "太原市"  
                }, {  
                    prov: "山西省",  
                    label: "大同市"  
                }, {  
                    prov: "山西省",  
                    label: "阳泉市"  
                }, {  
                    prov: "山西省",  
                    label: "长治市"  
                }, {  
                    prov: "山西省",  
                    label: "晋城市"  
                }, {  
                    prov: "山西省",  
                    label: "朔州市"  
                }, {  
                    prov: "山西省",  
                    label: "晋中市"  
                }, {  
                    prov: "山西省",  
                    label: "运城市"  
                }, {  
                    prov: "山西省",  
                    label: "忻州市"  
                }, {  
                    prov: "山西省",  
                    label: "临汾市"  
                }, {  
                    prov: "山西省",  
                    label: "吕梁市"  
                }, {  
                    prov: "内蒙古自治区",  
                    label: "呼和浩特市"  
                }, {  
                    prov: "内蒙古自治区",  
                    label: "包头市"  
                }, {  
                    prov: "内蒙古自治区",  
                    label: "乌海市"  
                }, {  
                    prov: "内蒙古自治区",  
                    label: "赤峰市"  
                }, {  
                    prov: "内蒙古自治区",  
                    label: "通辽市"  
                }, {  
                    prov: "内蒙古自治区",  
                    label: "鄂尔多斯市"  
                }, {  
                    prov: "内蒙古自治区",  
                    label: "呼伦贝尔市"  
                }, {  
                    prov: "内蒙古自治区",  
                    label: "巴彦淖尔市"  
                }, {  
                    prov: "内蒙古自治区",  
                    label: "乌兰察布市"  
                }, {  
                    prov: "内蒙古自治区",  
                    label: "兴安盟"  
                }, {  
                    prov: "内蒙古自治区",  
                    label: "锡林郭勒盟"  
                }, {  
                    prov: "内蒙古自治区",  
                    label: "阿拉善盟"  
                }, {  
                    prov: "辽宁省",  
                    label: "沈阳市"  
                }, {  
                    prov: "辽宁省",  
                    label: "大连市"  
                }, {  
                    prov: "辽宁省",  
                    label: "鞍山市"  
                }, {  
                    prov: "辽宁省",  
                    label: "抚顺市"  
                }, {  
                    prov: "辽宁省",  
                    label: "本溪市"  
                }, {  
                    prov: "辽宁省",  
                    label: "丹东市"  
                }, {  
                    prov: "辽宁省",  
                    label: "锦州市"  
                }, {  
                    prov: "辽宁省",  
                    label: "营口市"  
                }, {  
                    prov: "辽宁省",  
                    label: "阜新市"  
                }, {  
                    prov: "辽宁省",  
                    label: "辽阳市"  
                }, {  
                    prov: "辽宁省",  
                    label: "盘锦市"  
                }, {  
                    prov: "辽宁省",  
                    label: "铁岭市"  
                }, {  
                    prov: "辽宁省",  
                    label: "朝阳市"  
                }, {  
                    prov: "辽宁省",  
                    label: "葫芦岛市"  
                }, {  
                    prov: "吉林省",  
                    label: "长春市"  
                }, {  
                    prov: "吉林省",  
                    label: "吉林市"  
                }, {  
                    prov: "吉林省",  
                    label: "四平市"  
                }, {  
                    prov: "吉林省",  
                    label: "辽源市"  
                }, {  
                    prov: "吉林省",  
                    label: "通化市"  
                }, {  
                    prov: "吉林省",  
                    label: "白山市"  
                }, {  
                    prov: "吉林省",  
                    label: "松原市"  
                }, {  
                    prov: "吉林省",  
                    label: "白城市"  
                }, {  
                    prov: "吉林省",  
                    label: "延边朝鲜族自治州"  
                }, {  
                    prov: "黑龙江省",  
                    label: "哈尔滨市"  
                }, {  
                    prov: "黑龙江省",  
                    label: "齐齐哈尔市"  
                }, {  
                    prov: "黑龙江省",  
                    label: "鸡西市"  
                }, {  
                    prov: "黑龙江省",  
                    label: "鹤岗市"  
                }, {  
                    prov: "黑龙江省",  
                    label: "双鸭山市"  
                }, {  
                    prov: "黑龙江省",  
                    label: "大庆市"  
                }, {  
                    prov: "黑龙江省",  
                    label: "伊春市"  
                }, {  
                    prov: "黑龙江省",  
                    label: "佳木斯市"  
                }, {  
                    prov: "黑龙江省",  
                    label: "七台河市"  
                }, {  
                    prov: "黑龙江省",  
                    label: "牡丹江市"  
                }, {  
                    prov: "黑龙江省",  
                    label: "黑河市"  
                }, {  
                    prov: "黑龙江省",  
                    label: "绥化市"  
                }, {  
                    prov: "黑龙江省",  
                    label: "大兴安岭地区"  
                }, {  
                    prov: "上海市",  
                    label: "黄浦区"  
                }, {  
                    prov: "上海市",  
                    label: "卢湾区"  
                }, {  
                    prov: "上海市",  
                    label: "徐汇区"  
                }, {  
                    prov: "上海市",  
                    label: "长宁区"  
                }, {  
                    prov: "上海市",  
                    label: "静安区"  
                }, {  
                    prov: "上海市",  
                    label: "普陀区"  
                }, {  
                    prov: "上海市",  
                    label: "闸北区"  
                }, {  
                    prov: "上海市",  
                    label: "虹口区"  
                }, {  
                    prov: "上海市",  
                    label: "杨浦区"  
                }, {  
                    prov: "上海市",  
                    label: "闵行区"  
                }, {  
                    prov: "上海市",  
                    label: "宝山区"  
                }, {  
                    prov: "上海市",  
                    label: "嘉定区"  
                }, {  
                    prov: "上海市",  
                    label: "浦东新区"  
                }, {  
                    prov: "上海市",  
                    label: "金山区"  
                }, {  
                    prov: "上海市",  
                    label: "松江区"  
                }, {  
                    prov: "上海市",  
                    label: "青浦区"  
                }, {  
                    prov: "上海市",  
                    label: "南汇区"  
                }, {  
                    prov: "上海市",  
                    label: "奉贤区"  
                }, {  
                    prov: "上海市",  
                    label: "崇明县"  
                },{
                    prov: "江苏省",  
                    label: "南京市"  
                }, {  
                    prov: "江苏省",  
                    label: "无锡市"  
                }, {  
                    prov: "江苏省",  
                    label: "徐州市"  
                }, {  
                    prov: "江苏省",  
                    label: "常州市"  
                }, {  
                    prov: "江苏省",  
                    label: "苏州市"  
                }, {  
                    prov: "江苏省",  
                    label: "南通市"  
                }, {  
                    prov: "江苏省",  
                    label: "连云港市"  
                }, {  
                    prov: "江苏省",  
                    label: "淮安市"  
                }, {  
                    prov: "江苏省",  
                    label: "盐城市"  
                }, {  
                    prov: "江苏省",  
                    label: "扬州市"  
                }, {  
                    prov: "江苏省",  
                    label: "镇江市"  
                }, {  
                    prov: "江苏省",  
                    label: "泰州市"  
                }, {  
                    prov: "江苏省",  
                    label: "宿迁市"  
                }, {  
                    prov: "浙江省",  
                    label: "杭州市"  
                }, {  
                    prov: "浙江省",  
                    label: "宁波市"  
                }, {  
                    prov: "浙江省",  
                    label: "温州市"  
                }, {  
                    prov: "浙江省",  
                    label: "嘉兴市"  
                }, {  
                    prov: "浙江省",  
                    label: "湖州市"  
                }, {  
                    prov: "浙江省",  
                    label: "绍兴市"  
                }, {  
                    prov: "浙江省",  
                    label: "金华市"  
                }, {  
                    prov: "浙江省",  
                    label: "衢州市"  
                }, {  
                    prov: "浙江省",  
                    label: "舟山市"  
                }, {  
                    prov: "浙江省",  
                    label: "台州市"  
                }, {  
                    prov: "浙江省",  
                    label: "丽水市"  
                }, {  
                    prov: "安徽省",  
                    label: "合肥市"  
                }, {  
                    prov: "安徽省",  
                    label: "芜湖市"  
                }, {  
                    prov: "安徽省",  
                    label: "蚌埠市"  
                }, {  
                    prov: "安徽省",  
                    label: "淮南市"  
                }, {  
                    prov: "安徽省",  
                    label: "马鞍山市"  
                }, {  
                    prov: "安徽省",  
                    label: "淮北市"  
                }, {  
                    prov: "安徽省",  
                    label: "铜陵市"  
                }, {  
                    prov: "安徽省",  
                    label: "安庆市"  
                }, {  
                    prov: "安徽省",  
                    label: "黄山市"  
                }, {  
                    prov: "安徽省",  
                    label: "滁州市"  
                }, {  
                    prov: "安徽省",  
                    label: "阜阳市"  
                }, {  
                    prov: "安徽省",  
                    label: "宿州市"  
                }, {  
                    prov: "安徽省",  
                    label: "六安市"  
                }, {  
                    prov: "安徽省",  
                    label: "亳州市"  
                }, {  
                    prov: "安徽省",  
                    label: "池州市"  
                }, {  
                    prov: "安徽省",  
                    label: "宣城市"  
                }, {  
                    prov: "福建省",  
                    label: "福州市"  
                }, {  
                    prov: "福建省",  
                    label: "厦门市"  
                }, {  
                    prov: "福建省",  
                    label: "莆田市"  
                }, {  
                    prov: "福建省",  
                    label: "三明市"  
                }, {  
                    prov: "福建省",  
                    label: "泉州市"  
                }, {  
                    prov: "福建省",  
                    label: "漳州市"  
                }, {  
                    prov: "福建省",  
                    label: "南平市"  
                }, {  
                    prov: "福建省",  
                    label: "龙岩市"  
                }, {  
                    prov: "福建省",  
                    label: "宁德市"  
                }, {  
                    prov: "江西省",  
                    label: "南昌市"  
                }, {  
                    prov: "江西省",  
                    label: "景德镇市"  
                }, {  
                    prov: "江西省",  
                    label: "萍乡市"  
                }, {  
                    prov: "江西省",  
                    label: "九江市"  
                }, {  
                    prov: "江西省",  
                    label: "新余市"  
                }, {  
                    prov: "江西省",  
                    label: "鹰潭市"  
                }, {  
                    prov: "江西省",  
                    label: "赣州市"  
                }, {  
                    prov: "江西省",  
                    label: "吉安市"  
                }, {  
                    prov: "江西省",  
                    label: "宜春市"  
                }, {  
                    prov: "江西省",  
                    label: "抚州市"  
                }, {  
                    prov: "江西省",  
                    label: "上饶市"  
                }, {  
                    prov: "山东省",  
                    label: "济南市"  
                }, {  
                    prov: "山东省",  
                    label: "青岛市"  
                }, {  
                    prov: "山东省",  
                    label: "淄博市"  
                }, {  
                    prov: "山东省",  
                    label: "枣庄市"  
                }, {  
                    prov: "山东省",  
                    label: "东营市"  
                }, {  
                    prov: "山东省",  
                    label: "烟台市"  
                }, {  
                    prov: "山东省",  
                    label: "潍坊市"  
                }, {  
                    prov: "山东省",  
                    label: "济宁市"  
                }, {  
                    prov: "山东省",  
                    label: "泰安市"  
                }, {  
                    prov: "山东省",  
                    label: "威海市"  
                }, {  
                    prov: "山东省",  
                    label: "日照市"  
                }, {  
                    prov: "山东省",  
                    label: "莱芜市"  
                }, {  
                    prov: "山东省",  
                    label: "临沂市"  
                }, {  
                    prov: "山东省",  
                    label: "德州市"  
                }, {  
                    prov: "山东省",  
                    label: "聊城市"  
                }, {  
                    prov: "山东省",  
                    label: "滨州市"  
                }, {  
                    prov: "山东省",  
                    label: "菏泽市"  
                }, {  
                    prov: "河南省",  
                    label: "郑州市"  
                }, {  
                    prov: "河南省",  
                    label: "开封市"  
                }, {  
                    prov: "河南省",  
                    label: "洛阳市"  
                }, {  
                    prov: "河南省",  
                    label: "平顶山市"  
                }, {  
                    prov: "河南省",  
                    label: "安阳市"  
                }, {  
                    prov: "河南省",  
                    label: "鹤壁市"  
                }, {  
                    prov: "河南省",  
                    label: "新乡市"  
                }, {  
                    prov: "河南省",  
                    label: "焦作市"  
                }, {  
                    prov: "河南省",  
                    label: "濮阳市"  
                }, {  
                    prov: "河南省",  
                    label: "许昌市"  
                }, {  
                    prov: "河南省",  
                    label: "漯河市"  
                }, {  
                    prov: "河南省",  
                    label: "三门峡市"  
                }, {  
                    prov: "河南省",  
                    label: "南阳市"  
                }, {  
                    prov: "河南省",  
                    label: "商丘市"  
                }, {  
                    prov: "河南省",  
                    label: "信阳市"  
                }, {  
                    prov: "河南省",  
                    label: "周口市"  
                }, {  
                    prov: "河南省",  
                    label: "驻马店市"  
                }, {  
                    prov: "河南省",  
                    label: "省直辖县级行政区划"  
                }, {  
                    prov: "湖北省",  
                    label: "武汉市"  
                }, {  
                    prov: "湖北省",  
                    label: "黄石市"  
                }, {  
                    prov: "湖北省",  
                    label: "十堰市"  
                }, {  
                    prov: "湖北省",  
                    label: "宜昌市"  
                }, {  
                    prov: "湖北省",  
                    label: "襄阳市"  
                }, {  
                    prov: "湖北省",  
                    label: "鄂州市"  
                }, {  
                    prov: "湖北省",  
                    label: "荆门市"  
                }, {  
                    prov: "湖北省",  
                    label: "孝感市"  
                }, {  
                    prov: "湖北省",  
                    label: "荆州市"  
                }, {  
                    prov: "湖北省",  
                    label: "黄冈市"  
                }, {  
                    prov: "湖北省",  
                    label: "咸宁市"  
                }, {  
                    prov: "湖北省",  
                    label: "随州市"  
                }, {  
                    prov: "湖北省",  
                    label: "恩施土家族苗族自治州"  
                }, {  
                    prov: "湖北省",  
                    label: "省直辖县级行政区划"  
                }, {  
                    prov: "湖北省",  
                    label: "仙桃市"  
                }, {  
                    prov: "湖北省",  
                    label: "潜江市"  
                }, {  
                    prov: "湖北省",  
                    label: "天门市"  
                }, {  
                    prov: "湖北省",  
                    label: "神农架林区"  
                }, {  
                    prov: "湖南省",  
                    label: "长沙市"  
                }, {  
                    prov: "湖南省",  
                    label: "株洲市"  
                }, {  
                    prov: "湖南省",  
                    label: "湘潭市"  
                }, {  
                    prov: "湖南省",  
                    label: "衡阳市"  
                }, {  
                    prov: "湖南省",  
                    label: "邵阳市"  
                }, {  
                    prov: "湖南省",  
                    label: "岳阳市"  
                }, {  
                    prov: "湖南省",  
                    label: "常德市"  
                }, {  
                    prov: "湖南省",  
                    label: "张家界市"  
                }, {  
                    prov: "湖南省",  
                    label: "益阳市"  
                }, {  
                    prov: "湖南省",  
                    label: "郴州市"  
                }, {  
                    prov: "湖南省",  
                    label: "永州市"  
                }, {  
                    prov: "湖南省",  
                    label: "怀化市"  
                }, {  
                    prov: "湖南省",  
                    label: "娄底市"  
                }, {  
                    prov: "湖南省",  
                    label: "湘西土家族苗族自治州"  
                }, {  
                    prov: "广东省",  
                    label: "广州市"  
                }, {  
                    prov: "广东省",  
                    label: "韶关市"  
                }, {  
                    prov: "广东省",  
                    label: "深圳市"  
                }, {  
                    prov: "广东省",  
                    label: "珠海市"  
                }, {  
                    prov: "广东省",  
                    label: "汕头市"  
                }, {  
                    prov: "广东省",  
                    label: "佛山市"  
                }, {  
                    prov: "广东省",  
                    label: "江门市"  
                }, {  
                    prov: "广东省",  
                    label: "湛江市"  
                }, {  
                    prov: "广东省",  
                    label: "茂名市"  
                }, {  
                    prov: "广东省",  
                    label: "肇庆市"  
                }, {  
                    prov: "广东省",  
                    label: "惠州市"  
                }, {  
                    prov: "广东省",  
                    label: "梅州市"  
                }, {  
                    prov: "广东省",  
                    label: "汕尾市"  
                }, {  
                    prov: "广东省",  
                    label: "河源市"  
                }, {  
                    prov: "广东省",  
                    label: "阳江市"  
                }, {  
                    prov: "广东省",  
                    label: "清远市"  
                }, {  
                    prov: "广东省",  
                    label: "东莞市"  
                }, {  
                    prov: "广东省",  
                    label: "中山市"  
                }, {  
                    prov: "广东省",  
                    label: "潮州市"  
                }, {  
                    prov: "广东省",  
                    label: "揭阳市"  
                }, {  
                    prov: "广东省",  
                    label: "云浮市"  
                }, {  
                    prov: "广西壮族自治区",  
                    label: "南宁市"  
                }, {  
                    prov: "广西壮族自治区",  
                    label: "柳州市"  
                }, {  
                    prov: "广西壮族自治区",  
                    label: "桂林市"  
                }, {  
                    prov: "广西壮族自治区",  
                    label: "梧州市"  
                }, {  
                    prov: "广西壮族自治区",  
                    label: "北海市"  
                }, {  
                    prov: "广西壮族自治区",  
                    label: "防城港市"  
                }, {  
                    prov: "广西壮族自治区",  
                    label: "钦州市"  
                }, {  
                    prov: "广西壮族自治区",  
                    label: "贵港市"  
                }, {  
                    prov: "广西壮族自治区",  
                    label: "玉林市"  
                }, {  
                    prov: "广西壮族自治区",  
                    label: "百色市"  
                }, {  
                    prov: "广西壮族自治区",  
                    label: "贺州市"  
                }, {  
                    prov: "广西壮族自治区",  
                    label: "河池市"  
                }, {  
                    prov: "广西壮族自治区",  
                    label: "来宾市"  
                }, {  
                    prov: "广西壮族自治区",  
                    label: "崇左市"  
                }, {  
                    prov: "海南省",  
                    label: "海口市"  
                }, {  
                    prov: "海南省",  
                    label: "三亚市"  
                }, {  
                    prov: "海南省",  
                    label: "三沙市"  
                }, {  
                    prov: "海南省",  
                    label: "省直辖县级行政区划"  
                }, {  
                    prov: "海南省",  
                    label: "五指山市"  
                }, {  
                    prov: "海南省",  
                    label: "琼海市"  
                }, {  
                    prov: "海南省",  
                    label: "儋州市"  
                }, {  
                    prov: "海南省",  
                    label: "文昌市"  
                }, {  
                    prov: "海南省",  
                    label: "万宁市"  
                }, {  
                    prov: "海南省",  
                    label: "东方市"  
                }, {  
                    prov: "海南省",  
                    label: "定安县"  
                }, {  
                    prov: "海南省",  
                    label: "屯昌县"  
                }, {  
                    prov: "海南省",  
                    label: "澄迈县"  
                }, {  
                    prov: "海南省",  
                    label: "临高县"  
                }, {  
                    prov: "海南省",  
                    label: "白沙黎族自治县"  
                }, {  
                    prov: "海南省",  
                    label: "昌江黎族自治县"  
                }, {  
                    prov: "海南省",  
                    label: "乐东黎族自治县"  
                }, {  
                    prov: "海南省",  
                    label: "陵水黎族自治县"  
                }, {  
                    prov: "海南省",  
                    label: "保亭黎族苗族自治县"  
                }, {  
                    prov: "海南省",  
                    label: "琼中黎族苗族自治县"  
                }, {  
                    prov: "重庆市",  
                    label: "渝中区"  
                }, {  
                    prov: "重庆市",  
                    label: "大渡口区"  
                }, {  
                    prov: "重庆市",  
                    label: "江北区"  
                }, {  
                    prov: "重庆市",  
                    label: "沙坪坝区"  
                }, {  
                    prov: "重庆市",  
                    label: "九龙坡区"  
                }, {  
                    prov: "重庆市",  
                    label: "南岸区"  
                }, {  
                    prov: "重庆市",  
                    label: "北碚区"  
                }, {  
                    prov: "重庆市",  
                    label: "万盛区"  
                }, {  
                    prov: "重庆市",  
                    label: "双桥区"  
                }, {  
                    prov: "重庆市",  
                    label: "渝北区"  
                }, {  
                    prov: "重庆市",  
                    label: "巴南区"  
                }, {  
                    prov: "重庆市",  
                    label: "万州区"  
                }, {  
                    prov: "重庆市",  
                    label: "涪陵区"  
                }, {  
                    prov: "重庆市",  
                    label: "黔江区"  
                }, {  
                    prov: "重庆市",  
                    label: "长寿区"  
                }, {  
                    prov: "重庆市",  
                    label: "合川区"  
                }, {  
                    prov: "重庆市",  
                    label: "永川区"  
                }, {  
                    prov: "重庆市",  
                    label: "江津区"  
                }, {  
                    prov: "重庆市",  
                    label: "南川区"  
                }, {  
                    prov: "重庆市",  
                    label: "綦江县"  
                }, {  
                    prov: "重庆市",  
                    label: "潼南县"  
                }, {  
                    prov: "重庆市",  
                    label: "铜梁县"  
                }, {  
                    prov: "重庆市",  
                    label: "大足县"  
                }, {  
                    prov: "重庆市",  
                    label: "荣昌县"  
                }, {  
                    prov: "重庆市",  
                    label: "璧山县"  
                }, {  
                    prov: "重庆市",  
                    label: "垫江县"  
                }, {  
                    prov: "重庆市",  
                    label: "丰都县"  
                }, {  
                    prov: "重庆市",  
                    label: "城口县"  
                }, {  
                    prov: "重庆市",  
                    label: "梁平县"  
                }, {  
                    prov: "重庆市",  
                    label: "开县"  
                }, {  
                    prov: "重庆市",  
                    label: "巫溪县"  
                }, {  
                    prov: "重庆市",  
                    label: "巫山县"  
                }, {  
                    prov: "重庆市",  
                    label: "奉节县"  
                }, {  
                    prov: "重庆市",  
                    label: "云阳县"  
                }, {  
                    prov: "重庆市",  
                    label: "忠县"  
                }, {  
                    prov: "重庆市",  
                    label: "石柱土家族自治县"  
                }, {  
                    prov: "重庆市",  
                    label: "彭水苗族土家族自治县"  
                }, {  
                    prov: "重庆市",  
                    label: "酉阳土家族苗族自治县"  
                }, {  
                    prov: "重庆市",  
                    label: "秀山土家族苗族自治县"  
                }, {  
                    prov: "四川省",  
                    label: "成都市"  
                }, {  
                    prov: "四川省",  
                    label: "自贡市"  
                }, {  
                    prov: "四川省",  
                    label: "攀枝花市"  
                }, {  
                    prov: "四川省",  
                    label: "泸州市"  
                }, {  
                    prov: "四川省",  
                    label: "德阳市"  
                }, {  
                    prov: "四川省",  
                    label: "绵阳市"  
                }, {  
                    prov: "四川省",  
                    label: "广元市"  
                }, {  
                    prov: "四川省",  
                    label: "遂宁市"  
                }, {  
                    prov: "四川省",  
                    label: "内江市"  
                }, {  
                    prov: "四川省",  
                    label: "乐山市"  
                }, {  
                    prov: "四川省",  
                    label: "南充市"  
                }, {  
                    prov: "四川省",  
                    label: "眉山市"  
                }, {  
                    prov: "四川省",  
                    label: "宜宾市"  
                }, {  
                    prov: "四川省",  
                    label: "广安市"  
                }, {  
                    prov: "四川省",  
                    label: "达州市"  
                }, {  
                    prov: "四川省",  
                    label: "雅安市"  
                }, {  
                    prov: "四川省",  
                    label: "巴中市"  
                }, {  
                    prov: "四川省",  
                    label: "资阳市"  
                }, {  
                    prov: "四川省",  
                    label: "阿坝藏族羌族自治州"  
                }, {  
                    prov: "四川省",  
                    label: "甘孜藏族自治州"  
                }, {  
                    prov: "四川省",  
                    label: "凉山彝族自治州"  
                }, {  
                    prov: "贵州省",  
                    label: "贵阳市"  
                }, {  
                    prov: "贵州省",  
                    label: "六盘水市"  
                }, {  
                    prov: "贵州省",  
                    label: "遵义市"  
                }, {  
                    prov: "贵州省",  
                    label: "安顺市"  
                }, {  
                    prov: "贵州省",  
                    label: "毕节市"  
                }, {  
                    prov: "贵州省",  
                    label: "铜仁市"  
                }, {  
                    prov: "贵州省",  
                    label: "黔西南布依族苗族自治州"  
                }, {  
                    prov: "贵州省",  
                    label: "黔东南苗族侗族自治州"  
                }, {  
                    prov: "贵州省",  
                    label: "黔南布依族苗族自治州"  
                }, {  
                    prov: "云南省",  
                    label: "昆明市"  
                }, {  
                    prov: "云南省",  
                    label: "曲靖市"  
                }, {  
                    prov: "云南省",  
                    label: "玉溪市"  
                }, {  
                    prov: "云南省",  
                    label: "保山市"  
                }, {  
                    prov: "云南省",  
                    label: "昭通市"  
                }, {  
                    prov: "云南省",  
                    label: "丽江市"  
                }, {  
                    prov: "云南省",  
                    label: "普洱市"  
                }, {  
                    prov: "云南省",  
                    label: "临沧市"  
                }, {  
                    prov: "云南省",  
                    label: "楚雄彝族自治州"  
                }, {  
                    prov: "云南省",  
                    label: "红河哈尼族彝族自治州"  
                }, {  
                    prov: "云南省",  
                    label: "文山壮族苗族自治州"  
                }, {  
                    prov: "云南省",  
                    label: "西双版纳傣族自治州"  
                }, {  
                    prov: "云南省",  
                    label: "大理白族自治州"  
                }, {  
                    prov: "云南省",  
                    label: "德宏傣族景颇族自治州"  
                }, {  
                    prov: "云南省",  
                    label: "怒江傈僳族自治州"  
                }, {  
                    prov: "云南省",  
                    label: "迪庆藏族自治州"  
                }, {  
                    prov: "西藏自治区",  
                    label: "拉萨市"  
                }, {  
                    prov: "西藏自治区",  
                    label: "昌都地区"  
                }, {  
                    prov: "西藏自治区",  
                    label: "山南地区"  
                }, {  
                    prov: "西藏自治区",  
                    label: "日喀则地区"  
                }, {  
                    prov: "西藏自治区",  
                    label: "那曲地区"  
                }, {  
                    prov: "西藏自治区",  
                    label: "阿里地区"  
                }, {  
                    prov: "西藏自治区",  
                    label: "林芝地区"  
                }, {  
                    prov: "陕西省",  
                    label: "西安市"  
                }, {  
                    prov: "陕西省",  
                    label: "铜川市"  
                }, {  
                    prov: "陕西省",  
                    label: "宝鸡市"  
                }, {  
                    prov: "陕西省",  
                    label: "咸阳市"  
                }, {  
                    prov: "陕西省",  
                    label: "渭南市"  
                }, {  
                    prov: "陕西省",  
                    label: "延安市"  
                }, {  
                    prov: "陕西省",  
                    label: "汉中市"  
                }, {  
                    prov: "陕西省",  
                    label: "榆林市"  
                }, {  
                    prov: "陕西省",  
                    label: "安康市"  
                }, {  
                    prov: "陕西省",  
                    label: "商洛市"  
                }, {  
                    prov: "甘肃省",  
                    label: "兰州市"  
                }, {  
                    prov: "甘肃省",  
                    label: "嘉峪关市"  
                }, {  
                    prov: "甘肃省",  
                    label: "金昌市"  
                }, {  
                    prov: "甘肃省",  
                    label: "白银市"  
                }, {  
                    prov: "甘肃省",  
                    label: "天水市"  
                }, {  
                    prov: "甘肃省",  
                    label: "武威市"  
                }, {  
                    prov: "甘肃省",  
                    label: "张掖市"  
                }, {  
                    prov: "甘肃省",  
                    label: "平凉市"  
                }, {  
                    prov: "甘肃省",  
                    label: "酒泉市"  
                }, {  
                    prov: "甘肃省",  
                    label: "庆阳市"  
                }, {  
                    prov: "甘肃省",  
                    label: "定西市"  
                }, {  
                    prov: "甘肃省",  
                    label: "陇南市"  
                }, {  
                    prov: "甘肃省",  
                    label: "临夏回族自治州"  
                }, {  
                    prov: "甘肃省",  
                    label: "甘南藏族自治州"  
                }, {  
                    prov: "青海省",  
                    label: "西宁市"  
                }, {  
                    prov: "青海省",  
                    label: "海东市"  
                }, {  
                    prov: "青海省",  
                    label: "海北藏族自治州"  
                }, {  
                    prov: "青海省",  
                    label: "黄南藏族自治州"  
                }, {  
                    prov: "青海省",  
                    label: "海南藏族自治州"  
                }, {  
                    prov: "青海省",  
                    label: "果洛藏族自治州"  
                }, {  
                    prov: "青海省",  
                    label: "玉树藏族自治州"  
                }, {  
                    prov: "青海省",  
                    label: "海西蒙古族藏族自治州"  
                }, {  
                    prov: "宁夏回族自治区",  
                    label: "银川市"  
                }, {  
                    prov: "宁夏回族自治区",  
                    label: "石嘴山市"  
                }, {  
                    prov: "宁夏回族自治区",  
                    label: "吴忠市"  
                }, {  
                    prov: "宁夏回族自治区",  
                    label: "固原市"  
                }, {  
                    prov: "宁夏回族自治区",  
                    label: "中卫市"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "乌鲁木齐市"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "克拉玛依市"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "吐鲁番地区"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "哈密地区"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "昌吉回族自治州"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "博尔塔拉蒙古自治州"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "巴音郭楞蒙古自治州"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "阿克苏地区"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "克孜勒苏柯尔克孜自治州"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "喀什地区"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "和田地区"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "伊犁哈萨克自治州"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "塔城地区"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "阿勒泰地区"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "自治区直辖县级行政区划"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "石河子市"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "阿拉尔市"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "图木舒克市"  
                }, {  
                    prov: "新疆维吾尔自治区",  
                    label: "五家渠市"  
                }, {  
                    prov: "台湾省",  
                    label: "台北市"  
                }, {  
                    prov: "台湾省",  
                    label: "高雄市"  
                }, {  
                    prov: "台湾省",  
                    label: "基隆市"  
                }, {  
                    prov: "台湾省",  
                    label: "台中市"  
                }, {  
                    prov: "台湾省",  
                    label: "台南市"  
                }, {  
                    prov: "台湾省",  
                    label: "新竹市"  
                }, {  
                    prov: "台湾省",  
                    label: "嘉义市"  
                }, {  
                    prov: "台湾省",  
                    label: "省直辖"  
                }, {  
                    prov: "香港特别行政区",  
                    label: "香港岛"  
                }, {  
                    prov: "香港特别行政区",  
                    label: "九龙"  
                }, {  
                    prov: "香港特别行政区",  
                    label: "新界"  
                }, {  
                    prov: "澳门特别行政区",  
                    label: "澳门半岛"  
                }, {  
                    prov: "澳门特别行政区",  
                    label: "澳门离岛"  
                }, {  
                    prov: "澳门特别行政区",  
                    label: "无堂区划分区域"  
                }];
                for (var val of allCity){
                    if (prov == val.prov){
//                      console.log(val);  
                        tempCity.push({label: val.label, value: val.label})  
                    }  
                }  
                this.citys = tempCity;
			}
		},
		
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.Limits = JSON.parse(sessionStorage.getItem("limits"))
			this.GetList(GetUnreservationlistlist,{page:this.Curpage,token:this.token,sort:"-submit_date"})
			this.GetDealerList(GetDealerlist)
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})
		}
	}

</script>

<style scoped>
	.el-select{
		width: 100px;
	}
	.el-select .el-input {
	    width: 130px;
	  }
  	.input-with-select .el-input-group__prepend {
	    background-color: #fff;
	  }
	  
	.el-form--inline .el-form-item{
		margin-right: 0;
	}
</style>


// WEBPACK FOOTER //
// CustomerReservation.vue?362e4e76